// extracted by mini-css-extract-plugin
module.exports = {"tableColumns":"styles_tableColumns__1eHuC","postponedCardGrid":"styles_postponedCardGrid__oJLCN","filterDropdownContent":"styles_filterDropdownContent__3cJB9"};